import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import Hero from './components/Hero';
import Credibility from './components/Credibility';
import About from './components/About';
import Services from './components/Services';
import Solutions from './components/Solutions';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import './styles/main.css';

const MainPage: React.FC = () => (
  <>
    <Hero />
    <Credibility />
    <About />
    <Services />
    <Solutions />
    <ContactUs />
  </>
);

const App: React.FC = () => {
  return (
    <Router>
      <div className="cv-app">
        <NavBar />
        <main>
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
